<footer class="app-footer">
  <nav class="container-fluid" aria-label="Footer menu">
    © {{ footerTitle }},
    <span title="{{ 'Published at date ' + appVersion.publishDate }}">{{ 'version: ' + appVersion.version }}</span>
  </nav>
</footer>
